function initLocationAutocomplete() {
  const locationContainers = document.querySelectorAll(".jb-location-container");

  locationContainers.forEach(locationContainer => {
    // Find the visible text input within the container
    const locationField = $('.jb-location', locationContainer);

    // Find the hidden input within the same container
    const locationIdField = $('.jb-location-id', locationContainer);

    if (locationField.length === 0 || locationIdField.length === 0) {
      return;
    }

    const loadedLocationsMap = {};

    if (locationIdField.val()) {
      loadedLocationsMap[locationField.val()] = locationIdField.val();
    }

    let source;

    locationField.autocomplete({
      source: function (request, response) {
        const filledLocation = locationField.data('filled-location');

        if (filledLocation && ((request.term).trim() !== filledLocation)) {
          locationIdField.val(null)
        }

        source && source.cancel();
        const CancelToken = axios.CancelToken;
        source = CancelToken.source();

        axios.get($jBoard.config.main_api_url + "/locations?query=" + encodeURIComponent(request.term), {
          cancelToken: source.token
        }).then(function (result) {
          let list = [];

          $.each(result.data.items, function (index, element) {
            element.label = element.name;
            list.push(element);
            loadedLocationsMap[element.name] = element.id;
          });

          response(list);
          locationField.removeClass("ui-autocomplete-loading");
        });
      },
      minLength: 2,
      select: function (event, ui) {
        locationIdField.val(ui.item.id);
      }
    });

    locationField.on('input', function(){
      let locationValue = ($(this).val()).trim();
      locationIdField.val(loadedLocationsMap[locationValue] ?? '');
    });
  });
}

$(initLocationAutocomplete);
